(function ($) {
	sBase64Forward = {
		'A':0 ,'B':1 ,'C':2 ,'D':3 ,'E':4 ,'F':5 ,'G':6 ,'H':7 ,'I':8 ,'J':9 ,
		'K':10,'L':11,'M':12,'N':13,'O':14,'P':15,'Q':16,'R':17,'S':18,'T':19,
		'U':20,'V':21,'W':22,'X':23,'Y':24,'Z':25,'a':26,'b':27,'c':28,'d':29,
		'e':30,'f':31,'g':32,'h':33,'i':34,'j':35,'k':36,'l':37,'m':38,'n':39,
		'o':40,'p':41,'q':42,'r':43,'s':44,'t':45,'u':46,'v':47,'w':48,'x':49,
		'y':50,'z':51,'0':52,'1':53,'2':54,'3':55,'4':56,'5':57,'6':58,'7':59,
		'8':60,'9':61,'+':62,'/':63
	};
	sBase64Reverse = [
		'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
		'S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j',
		'k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','0','1',
		'2','3','4','5','6','7','8','9','+','/'
	];
	
	function base64Encode(sIn)
	{
		var count = sIn.length;
		var i,index=-1,iBits,sOut = new Array(Math.ceil(count*4/3)); //pre-allocate the array
		var chars = sBase64Reverse;
		
		for(i = 0; i < count; i += 3) {
			iBits = (sIn.charCodeAt(i) << 16)
				+ ((sIn.charCodeAt(i + 1) & 0xff) << 8)
				+ (sIn.charCodeAt(i + 2) & 0xff);

			sOut[++index] = chars[iBits >> 18 & 0x3f];
			sOut[++index] = chars[iBits >> 12 & 0x3f];

			//tried to unroll this, but couldn't get results to match
			sOut[++index] = (i > count - 2) ? "=" : chars[iBits >> 6 & 0x3f];
			sOut[++index] = (i > count - 3) ? "=" : chars[iBits & 0x3f];
		}

		return sOut.join("");
	}
	
	function base64decode(sIn)
	{
		var count = sIn.length - 4;
		var i,index=-1,iBits,sOut = new Array(Math.floor(3*count/4)); //preallocate array
		var chars = sBase64Forward;
		var sfcc = String.fromCharCode; //reference the static method

		sIn = sIn.charAt(sIn.length-1) == '='
			? sIn.charAt(sIn.length-2) =='='
				? sIn.slice(0,-2)
				: sIn.slice(0,-1)
			: sIn;

		for(i = 0; i < count; i += 4)
		{
			iBits = (chars[sIn.charAt(i)] << 18)
				| (chars[sIn.charAt(i + 1)] << 12)
				| ((chars[sIn.charAt(i + 2)] & 0xff) << 6)
				| (chars[sIn.charAt(i + 3)] & 0xff);

			sOut[++index] = sfcc(iBits >> 16 & 0xff);
			sOut[++index] = sfcc(iBits >> 8 & 0xff);
			sOut[++index] = sfcc(iBits & 0xff);
		}

		//unroll last loop iteration
		iBits = (chars[sIn.charAt(i)] << 18)
			| (chars[sIn.charAt(i + 1)] << 12)
			| ((chars[sIn.charAt(i + 2)] & 0xff) << 6)
			| (chars[sIn.charAt(i + 3)] & 0xff);

		sOut[++index] = sfcc(iBits >> 16 & 0xff);
		sOut[++index] = (i > sIn.length - 3) ? "" : sfcc(iBits >> 8 & 0xff);
		sOut[++index] = (i > sIn.length - 4) ? "" : sfcc(iBits & 0xff);

		return sOut.join("");
	}
	
	if (typeof(btoa) != "undefined") {  //firefox native encoder
	/**
	Base 64 encoding function. By default adds the encoding leader
	@param {string} string raw string to encode
	@param {bool} bNoLeader pass true to disable the addition of the encoding leader
	@return {string} base64 encoded string
	@member jQuery
	*/
		$.toBase64 = function(s, bNoLeader) {
			var e = btoa(s);
			if (!bNoLeader) {
				e = "B64ENC" + e;
			}
			return e;
		}
	} else {
		/** @ignore */
		$.toBase64 = function(s, bNoLeader) {
			var e = base64Encode(s);
			if (!bNoLeader) {
				e = "B64ENC" + e;
			}
			return e;
		}
	}

	if (typeof(atob) != "undefined") { //firefox native decoder
	/**
	Base 64 decoding function.
	@param {string} string base 64 encoded string to decode
	@return {string} base64 decoded string. If the encoded string contains an encoding leader it is removed.
	@member jQuery
	*/
		$.fromBase64 = function(s) {
			if (s.indexOf("B64ENC") == 0) {
				s = s.substr(6, s.length);
			}
			return atob(s);
		}
	} else {
		/** @ignore */
		$.fromBase64 = function(s) {
			if (s.indexOf("B64ENC") == 0) {
				s = s.substr(6, s.length);
			}
			return base64decode(s);
		}
	}

})(jQuery);